export default __webpack_public_path__ + "static/media/sugar.00e2fa64.jpeg";